export const TAG_TYPE = {
    QUALITY_INSPECT: 'QUALITY_INSPECT',
    REVIEW_CALL: 'REVIEW_CALL',
    REVIEW_KEY_EVENT: 'REVIEW_KEY_EVENT',
    CUSTOMER_TAG: 'CUSTOMER_TAG',
    USER_TAG: 'USER_TAG',
    PRODUCT_TAG: 'PRODUCT_TAG',
    SENTIMENT_TAG: 'SENTIMENT_TAG',
};

export const TABS_TYPE = {
    intellect: 'intellect',
    label: 'label',
    events: 'events',
    customer: 'customer',
    user: 'user',
    product: 'product',
    sentiment: 'sentiment',
};
